
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import {Emit, Prop} from 'vue-property-decorator';

    @Component({})
    export default class ChallengeDialogAbort extends Vue {
        @Prop({required: true, default: false})
        open!: boolean;

        @Emit('onConfirm')
        onConfirm() { /**/
        }

        @Emit('onCancel')
        onCancel() { /**/
        }
    }

